export const PAYWALLED_CONTENT_SELECTORS = {
  OVERVIEW: 'overview',
  SUMMARY: 'summary',
  VIDEO_PLAY_BTN: 'video-play-btn',
  VIDEO_PLAY_BTN_SMALL: 'video-play-btn-small',
  JOIN_US: 'join-us',
};

export const LAST_VIEWED_PATHWAY_SLUG_COOKIE_NAME = 'last_viewed_pathway_slug';
export const VIDEO_PAGE_CUSTOM_BLOCKS_URL = '/videos/';
